import api from './api';

const service = {
  // 出力抑制(混雑緩和)情報アップロード
  async uploadTsoOutputSuppression(params, file) {
    const form = new FormData();
    form.append('file', file);
    return await api.post(`/files/csv/tso_output_suppression/${params.area_id}/${params.start_date}/${params.end_date}/`, form,{
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }, 
  // 出力抑制(混雑緩和)情報テンプレート取得
  async createTempleteTsoOutputSuppression(params) {
    return await api.get(`/files/templates/tso_output_suppression`, { params, responseType: 'blob', dataType: 'binary' });
  },
}

export default service;
